{
    "punk": {
        "key": "punk",
        "isDead": false,
        "position": {
            "x": 8,
            "y": 2,
            "z": 1
        },
        "affiliation": "bad",
        "defense": 0,
        "resistance": 0,
        "properties": []
    }
}